import React from 'react';

import { Stack, Typography } from '@metarouter-private/mr-mui';

export default function Documentation() {
  return (
    <Stack spacing={2} alignItems="flex-start">
      <Typography variant="h6">Pipeline Tags</Typography>
      <Typography variant="body2">
        Tags let you organize and group your pipelines. Tags can be created here or inline on the pipeline details page.
        Once created, tags can be assigned to pipelines and used to filter the pipelines list.
      </Typography>
      <Typography variant="body2">
        Tags that are currently attached to pipelines cannot be edited or deleted. To remove a tag, first unassign it
        from all pipelines.
      </Typography>
    </Stack>
  );
}
